import { render, staticRenderFns } from "./CompanyUpdate.vue?vue&type=template&id=836109da&scoped=true"
import script from "./CompanyUpdate.vue?vue&type=script&lang=js"
export * from "./CompanyUpdate.vue?vue&type=script&lang=js"
import style0 from "./CompanyUpdate.vue?vue&type=style&index=0&id=836109da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836109da",
  null
  
)

export default component.exports